import { Server, contentClient } from '@wajeez-web/core/api-base';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getUtilityUsersDatatable: ApiMethod<
  Server.GetAllUtilityUsersInput,
  Server.TableOfUtilityUsersColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_users_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: 'page',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getUtilityAnalysisDatatable: ApiMethod<
  Server.GetUtilityVouchersAnalysisInput,
  Server.TableOfUtilityVouchersAnalysisColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_vouchers_analysis_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: 'page',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getUtilityUsersLookups: ApiMethod<
  Server.GetAllUtilityUsersLookupsInput,
  Server.UtilityUserOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_users_lookups_get_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: 'modal',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getUtilityUserById: ApiMethod<
  number,
  Server.UtilityUserDetailsOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_users_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: 'modal',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createSaleUser: ApiMethod<
  Server.CreateUtilityUserHandlerInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_users_post_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: 'modal',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getUtilityDepartmentAnalysis: ApiMethod<
  Server.GetUtilityDepartmentAnalysisInput,
  Server.GetUtilityDepartmentAnalysisOutput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_utility_analysis_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getUtilityVoucher: ApiMethod<
  Server.GetVoucherForUtilityUserInput,
  Server.GetVoucherForUtilityUserOutput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_voucher_get_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'page',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const checkVoucherState: ApiMethod<
  number,
  Server.UtilityVoucherStateOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_checkState_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'page',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const updatePaymentMethod: ApiMethod<
  Server.UpdateUtilityVoucherPaymentMethodInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_updatePaymentMethod_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const updateUtilityUserActivation: ApiMethod<
  Server.UpdateUtilityUserActivationInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

    const response = await client.admin_UtilityUser_users_updateActivation_put_V1(
      data
    );

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const assignPromoCodeToUtilityUser: ApiMethod<
  Server.AssignPromoCodeAliasToUtilityUserInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Server.Server_UtilityUser_Client(
            undefined,
            contentClient
          );

          const response = await client.admin_UtilityUser_promocode_assign_post_V1(
            data
          );

          return response;
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue
  );
};

export const assignPublisherToUtilityUser: ApiMethod<
  Server.UpdateUtilityUserPublisherCommand,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Server.Server_UtilityUser_Client(
            undefined,
            contentClient
          );

          const response = await client.admin_UtilityUser_updatePublisher_put_V1(
            data
          );

          return response;
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue
  );
};

export const getUtilityPromoCodeAnalysis: ApiMethod<
  void,
  Server.ListWithTotalOutputOfDateWithCountOutputAndInteger,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_UtilityUser_Client(undefined, contentClient);

        const response = await client.admin_UtilityUser_promocode_analysis_get_V1();

        return response;
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
